var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/clipboard_list_check/filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-240.000000, -335.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-2",
    transform: "translate(48.000000, 335.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Clipboard-List-Check/Filled",
    transform: "translate(192.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,4.125 L14.6666667,4.125 C14.6666667,2.67714844 13.4708333,1.5 12,1.5 C10.5291667,1.5 9.33333333,2.67714844 9.33333333,4.125 L6,4.125 C4.89583333,4.125 4,5.00683594 4,6.09375 L4,20.53125 C4,21.6181641 4.89583333,22.5 6,22.5 L18,22.5 C19.1041667,22.5 20,21.6181641 20,20.53125 L20,6.09375 C20,5.00683594 19.1041667,4.125 18,4.125 Z M12,3.140625 C12.5541667,3.140625 13,3.57949219 13,4.125 C13,4.67050781 12.5541667,5.109375 12,5.109375 C11.4458333,5.109375 11,4.67050781 11,4.125 C11,3.57949219 11.4458333,3.140625 12,3.140625 Z M6.73333333,10.0886719 L7.2625,9.571875 C7.35,9.48574219 7.49166667,9.48574219 7.57916667,9.571875 L8.4375,10.425 L10.4208333,8.4890625 C10.5083333,8.40292969 10.65,8.40292969 10.7375,8.4890625 L11.2625,9.00996094 C11.35,9.09609375 11.35,9.23554688 11.2625,9.32167969 L8.5875,11.9302734 C8.5,12.0164062 8.35833333,12.0164062 8.27083333,11.9302734 L6.73333333,10.4003906 C6.64583333,10.3142578 6.64583333,10.1748047 6.73333333,10.0886719 Z M8,17.578125 C7.44583333,17.578125 7,17.1392578 7,16.59375 C7,16.0482422 7.44583333,15.609375 8,15.609375 C8.55416667,15.609375 9,16.0482422 9,16.59375 C9,17.1392578 8.55416667,17.578125 8,17.578125 Z M17.3333333,16.921875 C17.3333333,17.1023437 17.1833333,17.25 17,17.25 L11,17.25 C10.8166667,17.25 10.6666667,17.1023437 10.6666667,16.921875 L10.6666667,16.265625 C10.6666667,16.0851563 10.8166667,15.9375 11,15.9375 L17,15.9375 C17.1833333,15.9375 17.3333333,16.0851563 17.3333333,16.265625 L17.3333333,16.921875 Z M17.3333333,11.671875 C17.3333333,11.8523438 17.1541667,12 16.9333333,12 L10.4208333,12 L11.7666667,10.6875 L16.9333333,10.6875 C17.1541667,10.6875 17.3333333,10.8351563 17.3333333,11.015625 L17.3333333,11.671875 Z",
    id: "Icon",
    fill: "#191C24"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledTest);
export default __webpack_public_path__ + "static/media/icon-filled-test.973a85a5.svg";
export { ForwardRef as ReactComponent };